import "./Notifications.scss";
function Notifications({ info, setInfo }) {
	if (info) {
		setTimeout(() => setInfo(undefined), info.timeout ?? 3000);
		return (
			<div
				className='notification'
				style={{
					backgroundColor: info.background ?? "",
					color: info.color ?? "",
				}}
			>
				{info.message}
			</div>
		);
	}
}

export default Notifications;
